const Text = ({children, type = "body", classNames = null}) =>{

    const textTypes = {
        webtitle: "text-5xl font-bold",
        maintitle: "text-3xl font-bold",
        main: "text-3xl",
        buttontext: "text-lg md:text-xl lg:text-2xl font-medium",
        itemmain: "text-2xl font-bold",
        itemtext: "text-2xl font-medium",
        orderitem: "text-xl font-medium",
        title: "text-2xl font-bold tracking-wide",
        subtitle: "text-lg text-gray-600",
        body: "text-base text-gray-800",
        caption: "text-sm text-gray-500 italic",
        button: "uppercase text-sm font-medium tracking-wider",
    }

    const classes = `${textTypes[type] ?? ""} ${classNames}`.trim()
    const MainView = () =>(
        <span className={classes} style={{ userSelect: 'none' }}>{children}</span>
    )
    return MainView()
}

export default Text